var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoupeIcon18White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3893 6.879C12.3893 9.92223 9.92223 12.3893 6.879 12.3893C3.83577 12.3893 1.36874 9.92223 1.36874 6.879C1.36874 3.83577 3.83577 1.36874 6.879 1.36874C9.92223 1.36874 12.3893 3.83577 12.3893 6.879ZM10.2943 12.8517C9.28796 13.4283 8.12198 13.758 6.879 13.758C3.07983 13.758 0 10.6782 0 6.879C0 3.07983 3.07983 0 6.879 0C10.6782 0 13.758 3.07983 13.758 6.879C13.758 8.20022 13.3855 9.43444 12.7399 10.4824L17.5828 15.3253C17.9391 15.6817 17.9391 16.2594 17.5828 16.6158L16.4658 17.7328C16.1095 18.0891 15.5317 18.0891 15.1754 17.7328L10.2943 12.8517ZM12.5344 12.2126L16.2923 15.9706L15.8206 16.4423L12.0626 12.6843L12.5344 12.2126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9496 4.31271C9.55721 2.30682 6.84927 1.65661 4.68484 2.8602V2.8602C4.1445 3.31308 4.5522 4.18909 5.24662 4.0673L5.36933 4.04578C6.87817 3.21945 8.74976 3.64715 9.75836 5.00047V5.00047C10.2686 5.59167 11.2313 5.04106 10.9496 4.31271V4.31271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupeIcon18White);
export default __webpack_public_path__ + "static/media/loupe-icon-18-white.e0ac2922c4af1c680d4f78b065d513af.svg";
export { ForwardRef as ReactComponent };